import {Injectable, OnDestroy} from '@angular/core';
import {PatientAccountPreferencesProxy} from './patient.account.preferences.proxy';
import {takeUntilDestroy} from 'take-until-destroy';
import {AuthProviderService} from './auth-provider.service';

@Injectable({
  providedIn: 'root'
})
export class PatientAccountPreferencesService implements OnDestroy {

  constructor(private patientAccountPreferencesProxy: PatientAccountPreferencesProxy,
              private authProviderService: AuthProviderService) {
  }

  ngOnDestroy(): void { }

  public setDefaultAccountLanguage(languageKey: number): void {
    this.patientAccountPreferencesProxy.setDefaultAccountLanguage(languageKey)
      .pipe(takeUntilDestroy(this))
      .subscribe(() => {
        this.authProviderService.setAccountPreference(languageKey);
      });
  }
}
